import { useState } from 'react';
import { Button, Table } from '../../components/ui';

interface PortalRow {
  portalId: string;
  code: string;
  name: string;
  usersCount: number;
  isActive: boolean;
}

/**
 * Admin page: Portal management — list of configured portals.
 */
export function PortalsPage() {
  const [portals] = useState<PortalRow[]>([
    {
      portalId: '1',
      code: 'documentale',
      name: 'Documentale Dipendenti',
      usersCount: 0,
      isActive: true,
    },
    {
      portalId: '2',
      code: 'fatturazione',
      name: 'Fatturazione Online',
      usersCount: 0,
      isActive: false,
    },
  ]);

  const columns = [
    { key: 'name', header: 'Portale' },
    { key: 'code', header: 'Codice' },
    {
      key: 'isActive',
      header: 'Stato',
      render: (item: PortalRow) => item.isActive ? '🟢 Attivo' : '⚫ Inattivo',
    },
    {
      key: 'usersCount',
      header: 'Utenti',
      render: (item: PortalRow) => String(item.usersCount),
    },
  ];

  return (
    <div className="admin-portals-page">
      <div className="page-header">
        <h2>Gestione Portali</h2>
      </div>

      <Table<PortalRow>
        columns={columns}
        data={portals}
        keyField="portalId"
        emptyMessage="Nessun portale configurato."
      />
    </div>
  );
}
